import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { LicensingService } from '../licensing/licensing.service';
import { AsamcoUserService } from './asamco-user.service';

/** Custom route interface */
interface CustomRoute extends Route {
	/** add the licence module name to the router */
	licenceModuleName?: string;

	permission?: string;
}

/** Route guard to verify if the user is authorized (has the permission+licence) to view the page */
@Injectable({
	providedIn: 'root',
	deps: [AsamcoUserService, LicensingService, Router],
})
export class AsamcoRouterGuard implements CanActivate {
	/**
	 * Constructor
	 */
	constructor(private user: AsamcoUserService, private lic: LicensingService, private router: Router) {
		this.checkPermission = this.checkPermission.bind(this);
		this.canActivate = this.canActivate.bind(this);
	}

	/** Handles whether the user can navigate to the requested route or not */
	async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		const route = (next.routeConfig as CustomRoute) || {};

		if (route.licenceModuleName) {
			if (await this.lic.hasLicence(route.licenceModuleName)) {
				if (await this.checkPermission(route)) {
					return true;
				}
			} else {
				console.warn('trying to activate a router without correct license', next.url); //NOSONAR
				return this.router.createUrlTree(['/application-link/dashboard']);
			}
		} else {
			if (await this.checkPermission(route)) {
				return true;
			}
		}

		console.warn('trying to activate a router without correct permission', next.url); //NOSONAR
		return this.router.createUrlTree(['/application-link/dashboard']);
	}

	/** internal function to check the permission when there is one. When there is none, it's always allowed */
	private async checkPermission(data): Promise<boolean> {
		if (data.permission === undefined) {
			return true;
		}
		return this.user.hasPermission(data.permission);
	}
}
